import script from "./RankedView.vue?vue&type=script&setup=true&lang=js"
export * from "./RankedView.vue?vue&type=script&setup=true&lang=js"

import "./RankedView.vue?vue&type=style&index=0&id=c2b3044e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2b3044e"]])

export default __exports__